"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
const react_1 = __importDefault(require("react"));
const react_loading_1 = __importDefault(require("react-loading"));
const prop_types_1 = __importDefault(require("prop-types"));
const CenterContent_1 = require("../CenterContent/CenterContent");
const LoadingComponent = ({ centeredVertical, type, color }) => {
    const loader = (react_1.default.createElement("div", { className: "loading" },
        react_1.default.createElement(react_loading_1.default, { color: color, delay: 0, type: type })));
    if (centeredVertical)
        return react_1.default.createElement(CenterContent_1.CenterContent, null, loader);
    return loader;
};
LoadingComponent.propTypes = {
    /** Center indicator vertically and horizontally */
    centeredVertical: prop_types_1.default.bool,
    /** Color of loading indicator */
    color: prop_types_1.default.string,
    /** Type of loading indicator */
    type: prop_types_1.default.string,
};
LoadingComponent.defaultProps = {
    centeredVertical: true,
    color: '#20A8D8',
    type: 'spin',
};
exports.Loading = LoadingComponent;
//# sourceMappingURL=Loading.js.map